import MetaTags from "../components/MetaTags";
import Article from "../components/Article";
import Cards from "../components/Cards";
import Hero from "../components/Hero";
import LocalSite from "../components/LocalSite";
import Qualities from "../components/Qualities";
import Sponsors from "../components/Sponsors";
import Testimonials from "../components/Testimonials";

const MainPage = () => {
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "2AH - Auvergne Amélioration de l'Habitat",
        "alternateName": "2AH",
        "url": "https://www.2-a-h.com",
        "logo": "https://www.2-a-h.com/logo-horizontal-long.svg",
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+33444449044",
            "contactType": "Customer Service",
            "areaServed": "FR",
            "availableLanguage": ["French"]
        },
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "6 rue Barbier d'Aubrée",
            "addressLocality": "BEAUMONT",
            "postalCode": "63110",
            "addressCountry": "FR"
        },
        "sameAs": []
    };

    return <>
        <MetaTags 
            title="2AH - Expert Rénovation Habitat Auvergne | Couverture, Isolation, Zinguerie" 
            description="2AH, spécialiste en Auvergne pour rénovation : couverture, isolation thermique, zinguerie, traitement nuisibles. Obtenez votre devis gratuit rapidement." 
        >
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema)}
            </script>
        </MetaTags>
        <Hero />
        <hr />
        <Qualities />
        <hr />
        <Cards />
        <hr />
        <Article />
        <hr />
        <LocalSite />
        <hr />
        <Testimonials />
        <hr />
        <Sponsors />
    </>;
  };
  
  export default MainPage;
  